import React, { useState } from 'react';
import styled from 'styled-components';
import { Palette } from 'core/config';
import { useAuthorization } from 'core/context';
import { resendVerify } from 'core/api';
import { useToast } from 'core/toast';

export const VerificationPending : React.FunctionComponent = () =>
{
    const [ hasSent, setHasSent ] = useState<boolean>(false);
    const authState = useAuthorization();
    const { setToastMessage } = useToast();

    const onResendEmail = async () => 
    {
        if (!hasSent)
        {
            setHasSent(true);
            await resendVerify(authState);
        }

        setToastMessage('Verification email sent');
    };
    
    return (
        <Container>
            <Header>
                Please check your email to verify your account.
            </Header>
            <br/>
            <Paragraph>
                Didn't receive a verification email? <a onClick={onResendEmail}>Click here</a> to resend it.
            </Paragraph>
            <Paragraph>
                If you have any questions or concerns, please feel free to email us at <a href="mailto:salaam@manzil.ca">salaam@manzil.ca</a>.
            </Paragraph>
        </Container>
    );
};

const Container = styled.div`
    display: flex;
    flex-direction: column;
    justify-content: center;
    height: calc(100vh - 232px);

    -webkit-touch-callout: none;
    -webkit-user-select: none;
    -khtml-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
`;

const Header = styled.div`
    flex-direction: row;
    color: ${Palette.BLUE};
    font: normal normal normal 27px 'SofiaPro-Bold';
    font-weight: 500;
    line-height: 28px;
    text-align: center;

    @media only screen and (max-width: 600px) {
        font-size: 21px;
    }
`;

const Paragraph = styled.p`
    flex-direction: row;
    font: normal normal normal 10px 'SofiaPro-Regular';
    color: ${Palette.BLUE};
    font-weight: light;
    text-align: center;

    :last-child {
        margin-top: -5px;
    }

    a {
        color: blue;
        text-decoration: underline;
        cursor: pointer;
    }

    @media only screen and (min-width: 1300px) {
        font-size: 12px;
    }

    @media only screen and (min-width: 1900px) {
        font-size: 14px;
    }
`;